import { getPlayerFromState } from './state';
import * as constants from './constants';
import log from './utils/logging';
import waitFor from './utils/waitFor';

/**
 * Sets base state and returns onBreakpointChange()
 *
 * @returns {Function}
 */

export function initializeOnScroll() {
  let floatingVideo;

  log.info(`initializeOnScroll(): called!`);

  const floaters = {}; // NOTE: shouldn't this be part of ./state instead?

  // TODO: handle default values for these better
  const initArticle = document.querySelector('article[data-id]') || document.body;
  const articleId = initArticle.getAttribute('data-id') || 0;

  const handleClick = (player, id) => {
    // TODO: why is `id` needed? Shouldn't that be available on `player`?
    const jwConf = player.getConfig();

    return () => {
      const state = player.getState();
      if (state === 'playing') {
        return;
      }

      if (floaters[id].el !== floatingVideo) {
        window.jwplayer(floatingVideo).setFloating(false);
        window.jwplayer(floatingVideo).setConfig({
          autostart: false,
        });
      }

      if (jwConf.floating.mode !== 'never') {
        player.setConfig({
          floating: {
            dismissible: true,
            mode: floaters[id].floatMode,
          },
        });

        floatingVideo = floaters[id].el;
      }
    };
  };

  waitFor(() => {
    if (window.jwplayer) {
      const JW_PLAYER_VIDEO_FRAME = '.jwplayer_video-frame';
      const JW_PLAYER = '.jwplayer';

      const firstEl = initArticle.querySelector(JW_PLAYER_VIDEO_FRAME);
      const documentEl = document.querySelector(JW_PLAYER_VIDEO_FRAME);
      return firstEl ? firstEl.querySelector(JW_PLAYER) : documentEl.querySelector(JW_PLAYER);
    }
  })
    .then((firstPlayerEl) => {
      const firstPlayer = window.jwplayer(firstPlayerEl);
      const firstPlayerConf = firstPlayer.getConfig();
      const statePlayer = getPlayerFromState(firstPlayer);
      const shouldAutostart = statePlayer.player.getConfig().autostart;
      const forceMute = shouldAutostart || statePlayer.isTop ? { mute: true } : {};
      const autostart = shouldAutostart !== false ? constants.firstVideoAutostart : false;
      const forceAutostart = statePlayer.isTop ? { autostart: true } : { autostart };
      firstPlayer.setConfig({ ...forceAutostart, ...forceMute });

      firstPlayer.on('displayClick', handleClick(firstPlayer, articleId));

      if (firstPlayerConf.floating.mode !== 'never') {
        floatingVideo = firstPlayerEl;

        if (!floaters[articleId]) {
          floaters[articleId] = {
            el: firstPlayerEl,
            floatMode: firstPlayerConf.floating.mode,
          };
        }
      }
    })
    .catch((e) => log.warn('infinityScroll waitFor catch:', e));

  function onBreakpointChange(breakpointEl) {
    const id = breakpointEl?.getAttribute('data-id');
    const articleEl = document.querySelector(`article[data-id="${id}"]`);
    const newPlayers = articleEl?.querySelectorAll('.jwplayer');

    (newPlayers || []).forEach((p) => {
      const jw = window.jwplayer(p);
      const jwConf = jw.getConfig();

      if (jwConf.floating.mode !== 'never' && !floaters[id]) {
        floaters[id] = {
          el: p,
          floatMode: jwConf.floating.mode,
        };

        jw.on('displayClick', handleClick(jw, id));
      }
    });
  }

  return onBreakpointChange;
}
